import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatPaginator } from '@angular/material';
import { HttpService } from '../http.service';
import { Messages } from '../constants/messages';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
export interface attachDriverData {
  driver_id: string;
  vehicle_id: string;
}
@Component({
  selector: 'app-attach-driver',
  templateUrl: './attach-driver.component.html',
  styleUrls: ['./attach-driver.component.scss']
})
export class AttachDriverComponent implements OnInit {
  columnsToDisplay = ['name', 'mobile', 'picture', 'action'];
  drivers: any = [];

  driverNameSeacrhKey;
  driverPhoneSeacrhKey;

  attachDriver: attachDriverData = {
    driver_id: '',
    vehicle_id: ''
  };
  errors = new Messages();
  totalDrivers = 0;
  driversFilter: any = {};
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  constructor(private dialog: MatDialogRef<AttachDriverComponent>, private translation:TranslateService,private openDialog: MatDialog, private http: HttpService, @Inject(MAT_DIALOG_DATA) private parentData: any,
              private snackbar: SnackbarService, private valid: ValidationService) { }

  ngOnInit() {
    this.getDrivers();
  }
  getDrivers(filter: any = {}) {
    filter.limit = this.paginator.pageSize || 10;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.http.get('driver/get_all', filter).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.drivers = [];
          const driversArray = data.data.drivers;
          this.totalDrivers = data.data.count;
          driversArray.forEach(element => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.name;
            temp.mobile = element.mobile;
            temp.picture = (element.profile_pic) ? element.profile_pic.original : 'assets/avatar.png';
            temp.action = '';
            temp.attachedVehicle = (element.attached_driver) ? element.attached_driver.vehicle_type : '';
            this.drivers.push(temp);
          });
          this.paginator._intl.itemsPerPageLabel= this.translation.instant('ATTACHDRIVER.pagination_label');
        }
      },
      (err: any) => {
        console.log('Err-=', err);
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('ATTACHDRIVER.pagination_label');
      }
    );
  }

  driverSearch(type = 'name') {
    const filter: any = {};
    if (type == 'mobile' && this.driverPhoneSeacrhKey != '') {
      filter.mobile = this.driverPhoneSeacrhKey;
    } else if(type == 'name' && this.driverNameSeacrhKey != ''){
      filter.name = this.driverNameSeacrhKey;
    }
    this.getDrivers(filter);
  }
  check(element) {
    if (!element.attachedVehicle) {
      this.attach(element);
    } else {
      this.attachDriver.vehicle_id = this.parentData._id;
      this.attachDriver.driver_id = element._id;
      const dialogData = {
        name: 'Attach Driver',
        text: this.errors.ATTACHDRIVER.DIALOGDATA.OVERWRITE,
        vehicle_id: this.parentData,
        driver_id: element._id,
        url: 'driver/attach'
      };
      const dialogref = this.openDialog.open(ConfirmationModalComponent, {
        data: dialogData
      });
      dialogref.afterClosed().subscribe(result => {
        if (result && result.statusCode == 200 || result == 'yes') {
          this.snackbar.openSnackBar(this.errors.ATTACHDRIVER.SUCCESS.ATTACHSUCCESSFULL, '');
          this.closeModal(result);
        }
      });
    }
  }
  pageNavigate(event) {
    this.driversFilter.limit = event.pageSize;
    this.driversFilter.skip = event.pageIndex * event.pageSize;
    this.getDrivers(this.driversFilter);
  }
  attach(element) {
    console.log(this.parentData);
    this.attachDriver.vehicle_id = this.parentData;
    this.attachDriver.driver_id = element._id;
    this.http.post('driver/attach', this.attachDriver).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar(this.errors.ATTACHDRIVER.SUCCESS.ATTACHSUCCESSFULL, '');
          this.closeModal(data);
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
            this.valid.logout();
          }
      }
    );
  }
  closeModal(data) {
    this.dialog.close(data);
  }
  closeDialog() {
    this.dialog.close();
  }
}
